import { render, staticRenderFns } from "./AppointmentDetailApp.vue?vue&type=template&id=470733a6"
import script from "./AppointmentDetailApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointmentDetailApp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppointmentDetailApp.vue?vue&type=style&index=0&id=470733a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports